import Header from "../components/header.jsx";
import Sidebar from "../components/sidebar.jsx";
import ReverseCustomerReport from "../components/reverseCustomerReport.jsx";
import Footer from "../components/footer.jsx";

function ReverseCustomerReportpage() {
    return (
        <div>
        <div className='wrapper'>
          <Header />
          <Sidebar /> 
          <ReverseCustomerReport/> 
        </div>
        <Footer /> 
      </div>
      // <Login/>
      );
}
export default ReverseCustomerReportpage;
